const Menu = [
    {
        label: "Te verwerken",
        pathname: "/stock/transfers"
    },
    {
        label: "Te controleren",
        pathname: "/stock/transfers/tocheck"
    },
    {
        label: "Klaar voor verzending",
        pathname: "/stock/transfers/tosend"
    },
    {
        label: "Op rondrit",
        pathname: "/stock/transfers/sent"
    },
    {
        label: "Geweigerde transfers",
        pathname: "/stock/transfers/rejected"
    }



];

export default Menu;